<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chtit"><a id="pagev"><em>Contents</em></a></h2><a id="pagev">
</a><p class="toc"><a id="pagev"></a><span href="#/xhtml/intro" title="Link target outside of Sample">Introduction</span></p>
<p class="toca"><em>Jim Casada</em></p>
<p class="toc"><span href="#/xhtml/ch001" title="Link target outside of Sample">Claws</span></p>
<p class="toc"><span href="#/xhtml/after" title="Link target outside of Sample">Afterword</span></p>
<p class="toca"><em>Ben McC. Moïse</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?26cbc80a